import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiFilter, FiChevronDown, FiX } = FiIcons;

const TagFilter = ({ tags, selectedTags, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleTag = (tagId) => {
    if (selectedTags.includes(tagId)) {
      onChange(selectedTags.filter(id => id !== tagId));
    } else {
      onChange([...selectedTags, tagId]);
    }
  };

  const clearFilters = () => {
    onChange([]);
  };

  const selectedTagNames = tags
    .filter(tag => selectedTags.includes(tag.id))
    .map(tag => tag.name);

  return (
    <div className="relative">
      <motion.button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-4 py-4 bg-white rounded-2xl border-2 border-gray-200 hover:border-indigo-500 transition-all duration-300 shadow-lg"
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
      >
        <div className="flex items-center space-x-3">
          <SafeIcon icon={FiFilter} className="text-gray-400" />
          <span className="text-gray-700">
            {selectedTags.length > 0 
              ? `${selectedTags.length} filter${selectedTags.length > 1 ? 's' : ''} applied`
              : 'Filter by tags'
            }
          </span>
        </div>
        <motion.div
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.2 }}
        >
          <SafeIcon icon={FiChevronDown} className="text-gray-400" />
        </motion.div>
      </motion.button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -10, scale: 0.95 }}
            className="absolute top-full left-0 right-0 mt-2 bg-white rounded-2xl border-2 border-gray-200 shadow-xl z-10 max-h-64 overflow-y-auto"
          >
            {selectedTags.length > 0 && (
              <div className="p-4 border-b border-gray-100">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm font-medium text-gray-700">Selected:</span>
                  <button
                    onClick={clearFilters}
                    className="text-xs text-red-600 hover:text-red-700 flex items-center space-x-1"
                  >
                    <SafeIcon icon={FiX} className="text-xs" />
                    <span>Clear all</span>
                  </button>
                </div>
                <div className="flex flex-wrap gap-2">
                  {selectedTagNames.map((tagName) => (
                    <span
                      key={tagName}
                      className="px-2 py-1 text-xs bg-gradient-to-r from-indigo-100 to-purple-100 text-indigo-700 rounded-lg"
                    >
                      {tagName}
                    </span>
                  ))}
                </div>
              </div>
            )}
            
            <div className="p-2">
              {tags.map((tag) => (
                <motion.button
                  key={tag.id}
                  onClick={() => toggleTag(tag.id)}
                  className={`w-full text-left px-3 py-2 rounded-lg transition-all duration-200 ${
                    selectedTags.includes(tag.id)
                      ? 'bg-gradient-to-r from-indigo-100 to-purple-100 text-indigo-700'
                      : 'hover:bg-gray-50 text-gray-700'
                  }`}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  {tag.name}
                </motion.button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default TagFilter;